import './selection-status.css';
import { Ticket } from 'lucide-react';

interface SelectionStatusProps {
  used: number;
  total: number;
  available: number;
}

export function SelectionStatus({
  used,
  total,
  available,
}: SelectionStatusProps) {
  const percentage = total > 0 ? (used / total) * 100 : 0;

  return (
    <div className="isg-selection-status">
      <div className="isg-selection-status-header">
        <Ticket className="isg-selection-status-icon" stroke="#90F7FF" />
        <h3 className="isg-selection-status-title">Tus Selecciones</h3>
      </div>

      <div className="isg-selection-status-content">
        <div className="isg-selection-status-counter">
          <span className="isg-selection-status-used">{used}</span>
          <span className="isg-selection-status-separator">/</span>
          <span className="isg-selection-status-total">{total}</span>
        </div>

        <div className="isg-selection-status-bar">
          <div
            className="isg-selection-status-progress"
            style={{ width: `${percentage}%` }}
          />
        </div>

        <div className="isg-selection-status-grid">
          <div className="isg-selection-status-box">
            <div className="isg-selection-status-label">Usadas</div>
            <div className="isg-selection-status-used-value">{used}</div>
          </div>

          <div className="isg-selection-status-box">
            <div className="isg-selection-status-label">Disponibles</div>
            <div className="isg-selection-status-available-value">
              {available}
            </div>
          </div>
        </div>

        {total === 0 && (
          <div className="isg-selection-status-empty">
            Compra tarjetas para comenzar a seleccionar tokens
          </div>
        )}
      </div>
    </div>
  );
}
